<template>
  <div class="list">
    <p>{{title}} <span>({{fileExtensions[name].join(', ')}})</span></p>
    <div class="load-image" :class="{invalid: errors[name].hasError, 'download-hover': hover, saved: savedFields.hasOwnProperty(name) && !changed}">
      <input :id="name" @change="processFile($event, name)" type="file" visibility="hidden">
      <template v-if="!isSelected">
        <icon-upload/>
        <span>Выбрать файл</span>
      </template>
      <template v-if="onUpload">
        <span class="file-load-label">Загрузка...</span>
        <v-progress-linear :indeterminate="true" height="5"
                           style="margin-bottom: 0; margin-top: -5px"></v-progress-linear>
      </template>
      <template v-if="name.split('_')[0] !== 'file'">
        <img v-if="item[name]" @load="onLoaded()" v-show="isLoaded" @click="showModal = true"
             :src="apiDomain + '/' + item[name]" class="zoom-image" title="Увеличить картинку">
        <a v-if="item[name]" target="_blank" :href="apiDomain + '/' + item[name]" :download="fileName" class="download"
           @mouseenter="hover = true" @mouseleave="hover = false">
          <icon-download/>
        </a>
       <div class="delete" @click="deleteFile" v-show="isLoaded" >
          <icon-delete/>
        </div>
      </template>
      <template v-else="">
        <img v-if="item[name]" @load="onLoaded()" v-show="isLoaded" src="@/assets/file.png">
        <a v-if="item[name]" target="_blank" :href="domain + '/' + item[name]" :download="fileName" class="download"
           @mouseenter="hover = true" @mouseleave="hover = false">
          <icon-download/>
        <div class="delete" @click="deleteFile" v-show="isLoaded">
          <icon-delete/>
        </div>
        </a>
      </template>
    </div>
    <div class="invalid_text" v-if="errors[name].hasError">{{errors[name].message}}</div>
    <transition name="fade">
    <div class="modal-image" @click.self="closeModal" v-if="showModal">
      <span class="close-icon" @click="closeModal"><icon-close/></span>
        <img :src="apiDomain + '/' + item[name]" v-show="showModal">
    </div>
    </transition>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import IconUpload from '../icons/IconUpload'
  import IconDownload from '../icons/IconDownload'
  import IconDelete from '../icons/IconDelete'
  import IconClose from '../icons/IconClose'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')

  export default {
    props: ['name', 'title', 'useCase', 'uploadFront', 'folder'],
    data () {
      return {
        hover: false,
        isSelected: false,
        isLoaded: false,
        onUpload: false,
        changed: false,
        showModal: false,
        oldName: ''
      }
    },
    computed: {
      ...mapState([
        'item',
        'isError',
        'errors',
        'fileExtensions',
        'savedFields'
      ]),
      apiDomain () {
        return this.$store.state.apiDomain
      },
      siteDomain () {
        return this.$store.state.siteDomain
      },
      domain () {
        return this.uploadFront ? this.siteDomain : this.apiDomain
      },
      fileName () {
        let path = this.item[this.name].split('/')
        return path[path.length - 1]
      }
    },
    methods: {
      ...mapMutations([
        'checkFile',
        'setItemField',
        'deleteItemField'

      ]),
      closeModal () {
        this.showModal = false
      },
      onLoaded () {
        this.isLoaded = true
        this.isSelected = true
      },
      deleteFile(){
        this.changed = true
        this.onUpload = false
        this.isLoaded = false
        this.isSelected = false
         this.setItemField({fieldName: this.name, value: null})
      },
      uploadFile (file) {
        this.changed = true
        this.onUpload = true
        this.isLoaded = false
        this.isSelected = true
        let data = new FormData()
        data.append('file', file)
        let url
        if (this.uploadFront === 'true') {
          url = '/api/uploadfile/front'
          data.append('folder', this.folder)
        } else {
          url = '/api/uploadfile?use_case=' + this.useCase
        }
        this.$http.post(url, data).then((response) => {
          this.onUpload = false
          if (this.uploadFront === 'true') this.isLoaded = true
          this.setItemField({fieldName: this.name, value: response.data.url})
        }).catch(error => {
          this.onUpload = false
          this.isLoaded = true
          this.$store.dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      },
      processFile (event) {
        let file = event.target.files[0]
        this.checkFile({name: this.name, fileName: file.name})
        if (!this.isError) {
          this.uploadFile(event.target.files[0])
        }
      }
    },
    components: {
      IconClose,
      IconDownload,
      IconUpload,
      IconDelete
    }
  }
</script>

<style lang="scss" scoped>
.delete,
  .download {
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: 0;
    display: flex;
    padding: 5px;
    border: solid #e4e8eb;
    border-width: 1px 0 0 1px;
    border-radius: 3px 0 0 0;
    background-color: #f8f9fb;
    overflow: hidden;
    transition: 0.3s;
    svg {
      margin: auto;
      color: #a4a6aa;
    }
    &:hover {
      transition: 0.3s;
      background: rgba(8, 156, 211, 0.2);
      svg {
        color: #089cd3 !important;
        animation: arrow 2s;
        animation-iteration-count: infinite;
      }
    }
  }

  .delete {
    bottom: unset;
    top: 0;
  }

  @keyframes arrow {
    0% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(19px);
    }
    25.01% {
      transform: translateY(-19px);
    }
    50% {
      transform: translateY(0);
    }

  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .zoom-image {
    position: relative;
    z-index: 2;
    transition: 0.3s;
  }

  .zoom-image:hover {
    cursor: zoom-in !important;
    transform: scale(1.2);
    transition: 0.3s;
  }

  .load-image {
    overflow: hidden;
  }

  .load-image:hover {
    .download {
      border-color: #089cd3;
      transition: 0.3s;
      svg {
        color: #999a9d;
      }
    }
  }

  .load-image.download-hover {
    border: 1px solid #089cd3 !important;
    transition: 0.3s;
  }

  .modal-image {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    padding: 5%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    .close-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      color: white;
      transition: 0.3s;
      svg {
        width: 18px;
        height: 18px;
      }
      &:hover {
        cursor: pointer;
        color: #089cd3;
        transition: 0.3s;
      }
    }
    img {
      margin: auto;
      max-height: 90%;
      max-width: 90%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/File.vue